import React from 'react';
export function Footer() {
  return <footer className="w-full bg-gray-900 text-white py-12" data-id="element-166">
      <div className="max-w-6xl mx-auto px-4" data-id="element-167">
        <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-168">
          <div data-id="element-169">
            <h4 className="font-bold mb-4" data-id="element-170">About Us</h4>
            <ul className="space-y-2 text-sm text-gray-400" data-id="element-171">
              <li data-id="element-172">
                <a href="#" className="hover:text-white" data-id="element-173">
                  Our Team
                </a>
              </li>
              <li data-id="element-174">
                <a href="#" className="hover:text-white" data-id="element-175">
                  Testing Process
                </a>
              </li>
              <li data-id="element-176">
                <a href="#" className="hover:text-white" data-id="element-177">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-178">
            <h4 className="font-bold mb-4" data-id="element-179">Reviews</h4>
            <ul className="space-y-2 text-sm text-gray-400" data-id="element-180">
              <li data-id="element-181">
                <a href="#" className="hover:text-white" data-id="element-182">
                  Elbow Braces
                </a>
              </li>
              <li data-id="element-183">
                <a href="#" className="hover:text-white" data-id="element-184">
                  Rackets
                </a>
              </li>
              <li data-id="element-185">
                <a href="#" className="hover:text-white" data-id="element-186">
                  Shoes
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-187">
            <h4 className="font-bold mb-4" data-id="element-188">Resources</h4>
            <ul className="space-y-2 text-sm text-gray-400" data-id="element-189">
              <li data-id="element-190">
                <a href="#" className="hover:text-white" data-id="element-191">
                  Buying Guides
                </a>
              </li>
              <li data-id="element-192">
                <a href="#" className="hover:text-white" data-id="element-193">
                  Injury Prevention
                </a>
              </li>
              <li data-id="element-194">
                <a href="#" className="hover:text-white" data-id="element-195">
                  FAQs
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-196">
            <h4 className="font-bold mb-4" data-id="element-197">Legal</h4>
            <ul className="space-y-2 text-sm text-gray-400" data-id="element-198">
              <li data-id="element-199">
                <a href="#" className="hover:text-white" data-id="element-200">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-201">
                <a href="#" className="hover:text-white" data-id="element-202">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-203">
                <a href="#" className="hover:text-white" data-id="element-204">
                  Disclosure
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 mb-6" data-id="element-205">
          <div className="bg-gray-800 border border-gray-700 rounded-lg p-6" data-id="element-206">
            <h4 className="font-bold text-white mb-3" data-id="element-207">
              ⚠️ Important Disclaimer
            </h4>
            <p className="text-sm text-gray-300 leading-relaxed mb-3" data-id="element-208">
              Claims about elbow braces and pain relief have not been evaluated
              by the MHRA. Products are not intended to diagnose, treat, cure,
              or prevent any medical condition. Results may vary based on
              individual injury severity and proper use. Please consult your GP,
              physiotherapist, or sports medicine specialist before using any
              elbow support, especially if you have existing medical conditions
              or chronic pain.
            </p>
            <p className="text-sm text-gray-300 italic" data-id="element-209">
              This is a paid advertorial and should be considered marketing
              content.
            </p>
          </div>
        </div>
        <div className="text-center text-sm text-gray-400" data-id="element-210">
          <p data-id="element-211">
            © 2025 Padel Review. All rights reserved. This is a paid
            advertorial.
          </p>
        </div>
      </div>
    </footer>;
}